/* eslint-disable filename-export/match-named-export */

/**
 * Pagina principal.
 *
 * @returns Componente de pagina principal.
 */
const Page = (): JSX.Element => {
  return (
    <>
      <h1>Welcome</h1>
      This page is:
      <ul>
        <li>Rendered to HTML.</li>
        <li />
      </ul>
    </>
  );
};

export { Page };
